import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // The proxy will handle redirecting this to http://localhost:3001/api
});

// Interceptor to add the auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
